import {Component, OnDestroy, OnInit, PipeTransform} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {UtilService} from "../../services/util.service";
import {DataService} from "../../services/data.service";

import {PriceHistoryDetailDialogComponent} from "../dialog/price-history-detail-dialog/price-history-detail-dialog.component";


@Component({
  selector: 'app-price-history',
  templateUrl: './price-history.component.html',
  styleUrls: ['./price-history.component.scss']
})
export class PriceHistoryComponent implements OnInit, OnDestroy {

  page1 = 1;
  pageSize1 = 5
  page2 = 1;
  pageSize2 = 5
  maxSizeOfPages = 7;
  enableBoundaryLink = true;
  market = 'ALL';
  startDateList = [];
  priceHistorySubscribe;
  priceHistoryList = [];
  priceHistoryPjmList = [];
  priceHistoryErcotList = [];
  loading = false;
  searchText;

  constructor(public utilService: UtilService, public  dataService: DataService
    , public dialog: MatDialog) {

  }

  ngOnInit(): void {

    this.getHistoryData()
    this.startDateList = this.utilService.getStartDateList(0);


  }

  restGetData() {
    this.loading = true;
    this.dataService.restPriceGetHistory().then((data) => {
      this.loading = false;
      this.getHistoryData()
    }).catch((error) => {
      this.loading = false;
    })
  }

  getHistoryData() {
    const data = this.dataService.getPriceHistory();
    if (!data) {
      this.restGetData();
      return
    }
    this.priceHistoryList = data;
    this.priceHistoryPjmList = this.priceHistoryList.filter(row => row.market == 'PJM');
    this.priceHistoryErcotList = this.priceHistoryList.filter(row => row.market == 'ERCOT');

  }

  openPriceDetail(row) {
    const dialogRef = this.dialog.open(PriceHistoryDetailDialogComponent
      , {
        data: {
          priceDetail: row
        }
        , panelClass: 'contract-generator-dialog'
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  formatAccountNumbers(accountNumbers) {
    let result = '';
    let accountList = accountNumbers.split(",");
    let maxIndex = Math.min(accountList.length, 3);
    for (let i = 0; i < maxIndex; i++) {
      if (i != 0) {
        result = result + ' , ';
      }
      result = result + accountList[i];
    }
    ;
    if (accountList.length > 3) {
      result = result + '....';
    }

    return result;

  }

  ngOnDestroy() {

  }

  search(): any {
    this.priceHistoryPjmList = this.priceHistoryList.filter(row => {
        if (this.searchText) {
          return row.market == 'PJM' && row.opportunityName && row.opportunityName.toLowerCase().includes(this.searchText.toLowerCase());
        } else {
          return row.market == 'PJM'
        }
      }
    );
    this.priceHistoryErcotList = this.priceHistoryList.filter(row => {
        if (this.searchText) {

          return row.market == 'ERCOT' && row.opportunityName && row.opportunityName.toLowerCase().includes(this.searchText.toLowerCase());
        } else {
          return row.market == 'ERCOT'
        }
      }
    );
  }


}
